import { useEffect, useState } from 'react';
import { useUser } from '@stackframe/react';
import { useAuth } from '../../context/AuthContext';

export default function StackAuthSync() {
  const stackUser = useUser();
  const { setUser, user: authUser } = useAuth();
  const [hasLogged, setHasLogged] = useState(false);

  // Log component mount and state changes
  useEffect(() => {
    if (!hasLogged) {
      console.log('🔄 StackAuthSync mounted');
      setHasLogged(true);
    }
    console.log('📊 StackAuthSync state:', {
      stackUser: stackUser ? stackUser.primaryEmail : 'null',
      authUser: authUser ? authUser.email : 'null',
      hasStackCookies: document.cookie.includes('stack-access')
    });
  }, [stackUser, authUser, hasLogged]);

  useEffect(() => {
    if (stackUser && !authUser) {
      console.log('✅ Syncing Stack Auth user to AuthContext:', stackUser.primaryEmail);
      
      const email = stackUser.primaryEmail;
      const displayName = stackUser.displayName || email?.split('@')[0];
      
      // Sync to database first to get/create user with proper role and admin_level
      fetch('/api', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'user.create',
          data: {
            email: email,
            displayName: displayName,
            provider: 'google',
            stack_user_id: stackUser.id
          }
        })
      })
      .then(response => response.json())
      .then(result => {
        if (result.success && result.user) {
          console.log('✅ User synced to database:', result.user);
          
          // Use the user data from database (includes role and admin_level)
          const user = {
            id: result.user.id,
            email: result.user.email,
            displayName: result.user.display_name || displayName,
            provider: result.user.provider,
            role: result.user.role,
            admin_level: result.user.admin_level,
            createdAt: result.user.created_at || new Date().toISOString()
          };
          
          // Store in AuthContext and localStorage
          setUser(user);
          localStorage.setItem('auth_user', JSON.stringify(user));
          console.log('✅ User stored in AuthContext and localStorage');
        } else {
          console.error('Failed to sync user to database:', result);
        }
      })
      .catch(error => {
        console.error('Error syncing user to database:', error);
      });
    }
  }, [stackUser, authUser, setUser]);

  return null; // This component doesn't render anything
}
